import { BASE } from '../components/Box/constants';

import { camelCase, capitalize } from './strings';

export const extractProp = (
  propName: string,
  props: Record<string, unknown>,
  hover = false,
  nonBaseProps: Array<string> = [],
): string => {
  let camelized = camelCase(propName);
  if (hover) camelized = `hover${capitalize(camelized)}`;

  const propValue = props[camelized];

  if (typeof propValue === 'undefined') return '';

  if (typeof propValue === 'string' || nonBaseProps.indexOf(propName) !== -1) {
    return `${propName}: ${propValue};`;
  }

  if (typeof propValue === 'number') {
    return `${propName}: ${propValue * BASE}px;`;
  }

  return '';
};

export const extractBooleanProps = (
  props: Record<string, unknown>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  booleanProps: Record<string, any>,
): string => {
  const keys = Object.keys(booleanProps);
  const values = keys.map(prop => {
    if (!props[prop]) return '';
    return booleanProps[prop];
  });

  return values.join('');
};

export const handleEllipsisProp = (props: {
  ellipsis?: boolean;
  lineHeight?: number | string;
}): string => {
  if (!props.ellipsis || !props.lineHeight) return '';

  return `
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: ${props.lineHeight};
  `;
};
